import React from 'react';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { ToolButton } from '../../../../components';
import { IToolButtonProps } from '../../../../interfaces';
import { getCurrentData, publish, useSubscription } from '../../../../hooks';
import { AlertTypeEnum, StateTopicEnum } from '../../../../enums';
import { CardsItemProps } from '..';
import { hideAlert, showAlert } from '../../../../components/alert/Alert';
import cardService from '../../services/cardService';
import { UserPermissions } from '../../../../../src/definitions';
import { securityService } from '../../../../../src/_global/services';
import { useAuthentication } from '../../../../hooks';
import { global } from '../../../../_config';

export default function SaveButton({ config, item }: IToolButtonProps) {
  const { id: moduleId, services } = config;
  const { _id: itemId } = item;
  const [invalid, setInvalid] = React.useState(true);
  const [cardsEditItem, setCardsEditItem] = React.useState(item);

  useSubscription(StateTopicEnum.IsValid, (valid: boolean) =>
    setInvalid(!valid)
  );

  useSubscription(StateTopicEnum.EditItem, (editItem: CardsItemProps) =>
    setCardsEditItem(editItem)
  );
  const auth = useAuthentication();
  const handleClick = async () => {
    const copy = { ...cardsEditItem };

    //add email address
    copy.email_address = global.utilities.extractAccountNameFromUser(
      auth?.user
    );

    // if spending categories comes through update them
    if (copy.spendingCategories) {
      await cardService.updateSpendingCategories(
        itemId,
        copy.spendingCategories
      );
      delete copy['spendingCategories'];
      delete copy['expanded'];
    }

    if (copy.card) {
      // services updated method could be undefined on other modules - hence the operator
      const { success, message }: any = await services.update!({
        ...copy,
        key: itemId
      });

      if (success) {
        const pageNo = getCurrentData(StateTopicEnum.LibraryPage);
        const searchTerm = getCurrentData(StateTopicEnum.LibrarySearch);
        publish(StateTopicEnum.LibrarySearchAndPage, {
          page: pageNo,
          search: searchTerm
        });
        publish(StateTopicEnum.Refresh, new Date());
        return true;
      } else {
        showAlert({
          content: message,
          options: {
            actions: [{ text: 'Okay', onClick: hideAlert, primary: true }],
            type: AlertTypeEnum.Error
          }
        });
      }
    } else return true;
  };

  return (
    <ToolButton
      text='Save'
      icon={faSave}
      path={`/${moduleId}/${itemId}`}
      primary
      raised
      onClick={handleClick}
      invalid={
        invalid || !securityService.checkRoleAccess(UserPermissions.editCards)
      }
    />
  );
}
